import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { products } from '../data/mockData';
import { useDragScroll } from '../hooks/useDragScroll';
export function Home() {
  const {
    selectedCountry
  } = useAppContext();
  const featuredProducts = products.slice(0, 4);
  const drops = useDragScroll<HTMLDivElement>();
  return <div className="flex flex-col w-full" data-id="element-76">
      {/* Hero Banner */}
      <div className="relative h-[420px] w-full overflow-hidden" data-id="element-77">
        <img src="https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?q=80&w=1000&auto=format&fit=crop" alt={`${selectedCountry.name} World Cup collection`} className="absolute inset-0 w-full h-full object-cover" data-id="element-78" />
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/40 to-transparent" data-id="element-79" />

        <div className="absolute bottom-0 left-0 w-full p-6 flex flex-col items-start" data-id="element-80">
          <div className="px-3 py-1 text-xs font-bold uppercase tracking-wider mb-3" style={{
          backgroundColor: selectedCountry.color,
          color: '#fff'
        }} data-id="element-81">
            {selectedCountry.name} Collection
          </div>
          <h1 className="font-display text-5xl leading-[0.9] mb-4 text-white" data-id="element-82">
            READY FOR
            <br data-id="element-83" />
            THE WORLD
          </h1>
          <Link to={`/shop?country=${selectedCountry.id}`} className="bg-white text-black px-6 py-3.5 font-display text-base flex items-center gap-2 hover:bg-zinc-200 transition-colors" data-id="element-84">
            SHOP {selectedCountry.name} <ArrowRight className="w-4 h-4" data-id="element-85" />
          </Link>
        </div>
      </div>

      {/* Categories */}
      <div className="px-4 py-8" data-id="element-86">
        <h2 className="font-display text-2xl mb-4" data-id="element-87">Shop By Category</h2>
        <div className="grid grid-cols-2 gap-3" data-id="element-88">
          <CategoryCard title="Jerseys" image="https://images.unsplash.com/photo-1614632537197-38a17061c2bd?q=80&w=400&auto=format&fit=crop" className="h-40" data-id="element-89" />
          <CategoryCard title="Cleats" image="https://images.unsplash.com/photo-1511886929837-354d827aae26?q=80&w=400&auto=format&fit=crop" className="h-40" data-id="element-90" />
          <CategoryCard title="Gear" image="https://images.unsplash.com/photo-1614632537423-1e6c2e7e0aab?q=80&w=400&auto=format&fit=crop" className="col-span-2 h-28" data-id="element-91" />
        </div>
      </div>

      {/* Featured Drops Carousel */}
      <div className="py-8 border-t border-zinc-900" data-id="element-92">
        <div className="px-4 mb-4 flex justify-between items-end" data-id="element-93">
          <h2 className="font-display text-2xl" data-id="element-94">Featured Drops</h2>
          <Link to="/shop" className="text-sm font-bold uppercase tracking-wider text-zinc-400 underline underline-offset-4" data-id="element-95">
            View All
          </Link>
        </div>
        <div ref={drops.ref} {...drops.dragProps} className="flex overflow-x-auto no-scrollbar px-4 gap-4 pb-4 select-none" data-id="element-96">
          {featuredProducts.map(product => <Link key={product.id} to={`/product/${product.id}`} className="shrink-0 w-[200px] flex flex-col group" data-id="element-97">
              <div className="relative aspect-[4/5] bg-zinc-900 mb-3 overflow-hidden" data-id="element-98">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-99" />
                {product.badges.length > 0 && <div className="absolute top-2 left-2 flex flex-col gap-1" data-id="element-100">
                    {product.badges.map(badge => <span key={badge} className="bg-white text-black text-[10px] font-bold uppercase px-2 py-1" data-id="element-101">
                        {badge}
                      </span>)}
                  </div>}
              </div>
              <div className="flex justify-between items-start gap-2" data-id="element-102">
                <div data-id="element-103">
                  <h3 className="font-bold text-sm leading-tight uppercase" data-id="element-104">
                    {product.name}
                  </h3>
                  <p className="text-xs text-zinc-400 mt-1" data-id="element-105">
                    {product.subtitle}
                  </p>
                </div>
                <span className="font-display text-sm" data-id="element-106">${product.price}</span>
              </div>
            </Link>)}
        </div>
      </div>
    </div>;
}
function CategoryCard({
  title,
  image,
  className = 'h-48'
}: {
  title: string;
  image: string;
  className?: string;
}) {
  return <Link to={`/shop?category=${title}`} className={`relative group overflow-hidden bg-zinc-900 ${className}`} data-id="element-107">
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-300" data-id="element-108" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" data-id="element-109" />
      <div className="absolute bottom-3 left-3" data-id="element-110">
        <h3 className="font-display text-xl text-white" data-id="element-111">{title}</h3>
      </div>
    </Link>;
}